import {UmpireImage} from '../umpire-image';
import {UmpireSquad} from '../umpire-squad';
import {UmpirePublicationOptions} from '../umpire-publication-options';
import {UmpireStaffMember} from '../umpire-staff-member';
import {UmpireStaffRole} from '../umpire-staff-role';

export class UmpireSquadStaffMember implements UmpirePublicationOptions {
  type!: string;

  id!: string;

  first_name!: string | null;

  last_name!: string | null;

  short_name!: string | null;

  staff_role!: UmpireStaffRole;

  squad!: UmpireSquad;

  image!: UmpireImage;

  staff_member!: UmpireStaffMember;

  status!: string | null;

  publication_time!: string | null;

  published_at!: string | null;

  is_draft!: boolean;

  slug!: string | null;
}
